import React from 'react'
import { Button } from '@resurs/midas-react'
import PropTypes from 'prop-types'
import { Dock } from '../../../components/common'
import { getText } from '../../../internal/TextLabels'
import cssStyles from '../chat.module.scss'

export const ChatBeforeCloseView = ({
  onClose,
  onBeforeCloseChat,
  onMinimize,
  onBackToStartedChat,
  title,
}) => {
  return (
    <Dock
      title={title}
      closeText={getText('default.close')}
      onBack={onClose}
      onMinimize={onMinimize}
      dockClass={cssStyles.dock}
      onBeforeCloseChat={onBeforeCloseChat}
    >
      <div className={cssStyles.beforeCloseDiv}>
        <span style={{ padding: '30px 0' }}>{getText('chat.endChat')}</span>
        <div>
          <Button fullWidth type="primary" onClick={onClose}>
            {getText('default.close')}
          </Button>
          <button
            className={cssStyles.backButton}
            type="button"
            onClick={onBackToStartedChat}
          >
            <i className={cssStyles.iconBack} />
            {getText('chat.backToChat')}
          </button>
        </div>
      </div>
    </Dock>
  )
}

ChatBeforeCloseView.propTypes = {
  onClose: PropTypes.func.isRequired,
  onBeforeCloseChat: PropTypes.func.isRequired,
  onBackToStartedChat: PropTypes.func.isRequired,
}
